import { render, staticRenderFns } from "./StandingsTopPane.vue?vue&type=template&id=ac5dc404&scoped=true"
import script from "./StandingsTopPane.vue?vue&type=script&lang=ts"
export * from "./StandingsTopPane.vue?vue&type=script&lang=ts"
import style0 from "./StandingsTopPane.vue?vue&type=style&index=0&id=ac5dc404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac5dc404",
  null
  
)

export default component.exports